<template>
  <div class="replaceBox" :class="{replaceBox_B: bCb_}">
    <h5>查找/替换</h5>
    <div class="seekBox">
      <div class="inputBox">
        <input type="text" v-model="seekTxt_" @input="seekChange" @change="seekChange" />
        <i class="seekIndex">{{ seekNum_ + "/" + seekNum2_ }}</i>
      </div>
      <i class="el-icon-top seekBut" @click="previous"></i>
    </div>
    <div>
      <input type="text" v-model="seekTxt2_" placeholder=" 不可替换原文" />
      <i class="el-icon-bottom seekBut" @click="seekNext"></i>
    </div>
    <div class="replaceBtn">
      <!-- <button @click="onReplace">替换</button> -->
      <button @click="seekChange">查找</button>
      <button @click="onReplace">替换</button>
      <button class="replace" @click="replaceChange">全部替换</button>
      <!-- <button @click="previous">上一个</button>
      <button @click="seekNext">下一个</button> -->
    </div>
  </div>
</template>
<script>
import eventBus from '../../../assets/js/eventBus'
export default {
  name: "seek",
  props: ["seekTxt", "seekTxt2", "seekNum", "seekNum2", "bCb"],
  data() {
    return {
    };
  },
  components: {},
  computed: {
    seekTxt_: {
      get() {
        return this.seekTxt
      },
      set(val) {
        this.$emit('onSeekTxt', val)
      }
    },
    seekTxt2_: {
      get() {
        return this.seekTxt2
      },
      set(val) {
        this.$emit('onSeekTxt2', val)
      }
    },
    seekNum_: function () {
      return this.seekNum;
    },
    seekNum2_: function () {
      return this.seekNum2;
    },
    bCb_: function () {
      console.log(this.bCb, "bcb");

      return this.bCb;
    },
  },
  methods: {
    seekChange() {
      setTimeout(() => {
        this.$emit('seekChange')
      }, 500);
    },
    onReplace() {
      this.$emit('onReplace')
    },
    replaceChange() {
      this.$emit('replaceChange')
    },
    previous() {
      this.$emit('previous')
    },
    seekNext() {
      this.$emit('seekNext')
    },
  },
};
</script>
<style lang="less" scoped>
.replaceBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 30px;
  .seekBut {
    line-height: 38px;
    font-size: 25px;
    margin-right: 10px;
    cursor: pointer;
  }
  h5 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    color: #222;
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;
    text-align: left;
  }
  div {
    width: 100%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    span {
      width: 24%;
      height: 36px;
      line-height: 36px;
    }
    input {
      width: 76%;
      height: 38px;
      line-height: 36px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 4px;
      box-sizing: border-box;
    }
    input:focus {
      outline: none;
      border: 1px solid #454545;
    }
  }
  .seekBox {
    position: relative;
    .inputBox {
      position: relative;
      width: 76%;
    }
    .seekIndex {
      position: absolute;
      right: 8px;
      top: 10px;
      background: white;
      font-size: 12px;
      // color: #C0C4CC;
    }
    input {
      padding-right: 10%;
      width: 100%;
      height: 38px;
      line-height: 36px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 4px;
    }
    input:focus {
      outline: none;
      border: 1px solid #454545;
    }
  }
  .replaceBtn {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-top: 10px;
    button {
      font-size: 12px;
      color: rgba(55, 141, 227, 1);
      background: rgba(231, 239, 255, 1);
      border: 1px solid rgba(55, 141, 227, 1);
      border-radius: 4px;
      width:60px;
      height: 38px;
      line-height: 38px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .replace{
      width:70px;
    }
    // button:hover {
    //   background: rgba(244, 244, 244, 1);
    // }
    button:active {
      background:rgba(51,143,255,1);
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(55, 141, 227, 1);
    }
  }
}
.replaceBox_B {
  h5 {
    color: #c6c6c6;
  }
  span {
    color: white !important;
  }
  input {
    background: #507383 !important;
    border: none !important;
    color: white !important;
  }
  input::-webkit-input-placeholder {
    color: white !important;
  }
  .seekBox {
    .seekIndex {
      background: #507383 !important;
    }
  }
  .replaceBtn {
    button {
      background:#507383 !important;
      border: none !important;
      color: white !important;
    }
    button:active{
      background: #2c4753 !important;
    }
  }
  .seekBut {
    color: white !important;
  }
}
</style>
